import { useState } from 'react';
import type { Eta, Gender, GenerationPhase, GenerationStep } from '../types/domain';

export interface GenerationFormState {
  step: GenerationStep;
  songName: string;
  songText: string;
  songDescription: string;
  /** Selected theme template (e.g. "День рождения"), sent to the backend as `theme`. */
  theme: string;
  selectedStyle: string;
  customStyle: string;
  gender: Gender;
  /** Sub-state while step === 'generating'. */
  phase: GenerationPhase | null;
  /** Present only while phase === 'awaiting_generation'. */
  eta: Eta | null;
}

const INITIAL: GenerationFormState = {
  step: 'start',
  songName: '',
  songText: '',
  songDescription: '',
  theme: '',
  selectedStyle: '',
  customStyle: '',
  gender: 'male',
  phase: null,
  eta: null,
};

export function useGenerationForm() {
  const [form, setForm] = useState<GenerationFormState>(INITIAL);

  const patch = (partial: Partial<GenerationFormState>) =>
      setForm((prev) => ({ ...prev, ...partial }));

  const reset = () => setForm(INITIAL);

  const goBack = () => {
    const map: Partial<Record<GenerationStep, GenerationStep>> = {
      text: 'start',
      style: 'text',
      vocal: 'style',
    };
    const next = map[form.step];
    if (next) patch({ step: next });
  };

  /** Toggle a theme template: clicking the active one deselects it. */
  const toggleTheme = (name: string) =>
      patch({ theme: form.theme === name ? '' : name });

  /** Effective style = preset or custom */
  const effectiveStyle = form.selectedStyle || form.customStyle;

  return { form, patch, reset, goBack, toggleTheme, effectiveStyle };
}